export const bodyContainer = "contactCss_bodyContainer";
export const successMessage = "contactCss_successMessage";
export const errorMessage = "contactCss_errorMessage";
export const contentContainer = "contactCss_contentContainer";
export const rightContainer = "contactCss_rightContainer";
export const submitBtn = "contactCss_submitBtn";
export const leftContainer = "contactCss_leftContainer";
export const detailContainer = "contactCss_detailContainer";
export const detailTitle = "contactCss_detailTitle";
export const detailIcon = "contactCss_detailIcon";
export const detailDesc = "contactCss_detailDesc";
